import { Controller } from "@hotwired/stimulus";
import moment from "moment";
import "moment/locale/nl";

export default class extends Controller {
  static targets = ["input", "userVisibleDate", "min"];
  static values = { format: String };
  static classes = ["inactive"];

  connect() {
    this.updateUserVisibleDate();
  }

  min() {
    if (this.inputTarget.value === "") return;

    this.inputTarget.value = moment(this.inputTarget.value).subtract(1, "day").format("YYYY-MM-DD");
    this.updateUserVisibleDate();
    this.emitEvent();
  }

  plus() {
    if (this.inputTarget.value === "") return;

    this.inputTarget.value = moment(this.inputTarget.value).add(1, "day").format("YYYY-MM-DD");
    this.updateUserVisibleDate();
    this.emitEvent();
  }

  emitEvent() {
    this.element.dispatchEvent(new Event("change", { bubbles: true }));
  }

  updateUserVisibleDate() {
    this.userVisibleDateTarget.innerHTML = moment(this.inputTarget.value).format(this.formatValue);

    this.inactiveClasses.forEach((className) => {
      const endOfToday = moment().startOf("day");

      const valueInInput = moment(this.inputTarget.value);
      const disableMin = valueInInput.isSameOrBefore(endOfToday);

      this.minTarget.classList.toggle(className, disableMin);
    });
  }
}
